export default __webpack_public_path__ + "static/iam_role_06-c6afafcb668afc3c54e48fae9bb65821.png";